function menuId(value, lang) {
  let candidate = value
  if (candidate && typeof candidate === 'object' && !candidate._id) candidate = candidate[lang]
  if (candidate && typeof candidate === 'object') candidate = candidate._id
  return typeof candidate === 'string' && /^[a-f\d]{24}$/i.test(candidate) ? candidate : undefined
}

export function localizedMenuText(value, lang) {
  if (typeof value === 'string') return value
  if (value && typeof value === 'object' && typeof value[lang] === 'string') return value[lang]
  return ''
}

export default function menuPayload(form, lang = 'fa') {
  const payload = {
    title: localizedMenuText(form.title, lang),
    slug: typeof form.slug === 'string' ? form.slug : '',
    description: localizedMenuText(form.description, lang),
    linkType: form.linkType || 'InternalLink',
    Link: typeof form.Link === 'string' ? form.Link : '',
  }
  const optionalIds = ['menuCategoryId', 'menuImageFileId', 'ServiceModelId']
  optionalIds.forEach(key => {
    const id = menuId(form[key], lang)
    if (id) payload[key] = id
  })
  if (typeof form.ServiceModelName === 'string' && form.ServiceModelName) payload.ServiceModelName = form.ServiceModelName
  return payload
}
